import * as React from "react";
import {Component} from "react";
import styles from "../../styles/flyouts/buildings/Properties.scss";
import * as _ from "lodash";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../core/utils";
import {setNotification} from "../../redux/actions/general/notification";
import {listBuildings, updateBuilding} from "../../redux/actions/table/buildings";
import EditBuildingForm from "../../forms/buildings/EditBuildingForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateBuilding(formData.id, _.omit(formData, ['id'])).then(() => {
                listBuildings(this.props.match.params.stage);

                this.props.readAction(formData.id);

                setNotification(__('buildings.flyout.notification.saved'));
            })
        );
    }

    render() {
        const {data} = this.props;

        return (
            <div className={styles.scroller}>
                <EditBuildingForm
                    onSubmit={this._handleSubmit}
                    data={data}
                    initialValues={{
                        ..._.pick(data, ['id', 'site_id', 'code', 'title', 'description', 'indoor_area', 'outdoor_area', 'volume', 'footprint', 'building_types']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
